import CustomButton from "../../../components/CustomButton";
import Input from "../../../components/form/Input";
import CustomModal from "../../../components/CustomModal";
import {useDispatch, useSelector} from "react-redux";
import useInput from "../../../hooks/useInput";
import useDidMount from "../../../hooks/useDidMount";
import {setManageFeatureModals, tryAddOrUpdateFeature} from "../../../redux/slices/permissionSlice";


export default function CreateFeatureFormModal({}) {

  const {modal, data} = useSelector((state => state.permission.modals.form));
  const dispatch = useDispatch();
  const featureName = useInput("")

  const {
    loading: editing,
  } = useSelector((state) => state.dynamicElements.editing);
  const isEditForm = !!data;
  const isFormValid = featureName.value.trim()


  const submitForm = ()=>{
    dispatch(tryAddOrUpdateFeature({
      "name": featureName.value.trim(),
      "frontend_key": featureName.value.trim()
    }))
  }

  useDidMount(()=>{
    if(!modal){
      featureName.setValue("")
    }else if(isEditForm){
      featureName.setValue(data.name)
    }
  }, [modal])


  return (
    <CustomModal title={isEditForm ? "Update Feature" : "Create New Feature"}
                 bodyClasses="max-w-screen-sm"
                 showModal={modal}
                 setShowModal={() => dispatch(setManageFeatureModals())}
                 loading={editing}
                 button={<CustomButton disabled={editing || !isFormValid}
                                       onClick={submitForm}>{isEditForm ? "Update" : "Create"}</CustomButton>}>
      <div className="flex flex-col p-2 space-y-4">



        <Input label="Name" type="text" color="lightBlue" size="lg" placeholder="Name"
               hideError={true}
               disabled={editing} value={featureName.value}
               errorMessage="invalid name"
               onChange={featureName.onChange}/>




      </div>
    </CustomModal>
  );
}